import { Auth } from "aws-amplify";

export async function getAuthHeader() {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  return { Authorization: `Bearer ${token}` };
}
